module.exports = __webpack_public_path__ + "static/flags/MY-8a423b23bf076abd59cee5167c76bc68.gif";